module.exports = __webpack_public_path__ + "static/media/IMG_1266.89565779.png";